import { SVGProps } from "react";

export const FieldIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.24019 13.8261L1.86829 6.49624C1.56344 6.19313 1.56115 5.84282 1.70047 5.63073C2.75321 4.02817 5.25826 1.22534 10.0001 1.22534C14.7351 1.22534 17.2397 4.02127 18.2952 5.62567C18.4353 5.83866 18.4324 6.19094 18.1235 6.49405L10.6456 13.8308C10.2548 14.2142 9.6284 14.2121 9.24019 13.8261Z"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);

export const HomePlateIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.37843 1.07666H14.3313C14.8835 1.07666 15.3311 1.52415 15.3313 2.0763L15.3332 7.1533C15.3333 7.41645 15.2297 7.66902 15.0448 7.85627L9.04508 13.9327C8.65356 14.3292 8.01344 14.3292 7.62191 13.9327L1.62817 7.8623C1.44152 7.67327 1.33776 7.41774 1.33978 7.15209L1.37846 2.06905C1.38263 1.51975 1.82911 1.07666 2.37843 1.07666Z"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);

export const BullpenIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 17 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.666504"
      y="0.422607"
      width="16"
      height="3.30816"
      rx="0.5"
      fill="currentColor"
    />
  </svg>
);
